
export default {
  name: 'HomeVideoBg',
}
